import axios_service from './base_request'
import qs from 'qs'

function get(path, params) {
   return  axios_service({
        url:  path,
        method: 'get',
        params
     })
}

function post(path, data) {
   return axios_service({
        url:  path,
        method: 'post',
        data:qs.stringify(data)
     })
}

function postFile(path, params,data) {
   return axios_service({
        url:  path,
        method: 'post',
        headers:{"Content-Type": "multipart/form-data"},
        params: params,
        data
     })
}

export default {
   get,
   post,
   postFile
}